/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menureadinglunchtitle3Inputs */

const en_menureadinglunchtitle3 = /** @type {(inputs: Menureadinglunchtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify is reading your lunch menu`)
};

const de_menureadinglunchtitle3 = /** @type {(inputs: Menureadinglunchtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify liest dein Mittagsmenü`)
};

/**
* | output |
* | --- |
* | "Pulsify is reading your lunch menu" |
*
* @param {Menureadinglunchtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menureadinglunchtitle3 = /** @type {((inputs?: Menureadinglunchtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menureadinglunchtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menureadinglunchtitle3(inputs)
	return de_menureadinglunchtitle3(inputs)
});
export { menureadinglunchtitle3 as "menuReadingLunchTitle" }